const PagingData = {
  defaultCurrentPage: 1,
  defaultCountPerPage: 10,
  defaultType: '',
};

export { PagingData };
